import * as React from "react";

import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";

import clockIcon from "@phosphor-icons/core/bold/clock-bold.svg";

export const ClockIcon = (): React.ReactElement => (
    <PhosphorIcon icon={clockIcon} size="small" />
);
